/**
 * A ticket's page address as a card's Open tooltip shows it (Jason, 25 Oct):
 * the host and path without the scheme, the query or the fragment, which is
 * where long ids and tokens sit, and at most `max` characters, ending in an
 * ellipsis when cut. The button still opens the full address.
 */
export function sourceUrlLabel(url: string, max = 60): string {
  let label = url;
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      label = parsed.host + (parsed.pathname === '/' ? '' : parsed.pathname);
    }
  } catch {
    // Not an address the URL parser reads: shown as stored, still capped.
  }
  return label.length > max ? `${label.slice(0, max - 1)}…` : label;
}
